import AppRouter from './AppRouter';
import Footer from "./components/Footer";

function App() {
  return (
    <div >
      <AppRouter />
      <Footer/>
    </div>
  );
}

export default App;
